import React from "react"
import Stack from "@mui/material/Stack"
import useCountdown from "@src/hooks/use-countdown"



const Item = ({ value }) => (
  <Stack
    justifyContent="center"
    alignItems="center"
    sx={{
      minWidth: "44px",
      borderRadius: "10px",
      padding: "8px 10px",
      backgroundColor: "#F6F6F6",
      fontSize: "24px",
      fontWeight: 500
    }}
  >
    {value < 10 ? `0${value}` : value}
  </Stack>
)

const CountdownSale = ({ remainSeconds }) => {
  const { seconds: secondRemain, setSeconds: resetTimeout } = useCountdown(remainSeconds)
 
  const hours = Math.floor(secondRemain / 3600)
  const minutes = Math.floor((secondRemain % 3600) / 60)
  const seconds = secondRemain % 60

  if (Number(remainSeconds) <= 0) { 
    return null
  }

  return (
    <Stack
      direction="row"
      alignItems="center"
      justifyContent="center"
      gap="10px"
    >
      <Item value={hours} />
      <Item value={minutes} />
      <Item value={seconds} />
    </Stack>
  )
}

export default CountdownSale
